import RouteManager, { PAGE_ROUTES } from "../RouteManager";
import Dashboard from "./../../components/dashboard/Dashboard";
import Contacts from "./../../components/contacts/Contacts";
import Funnel from "./../../components/funnel/Funnel";
import Campaign from "./../../components/campaign/Campaign";
import CampaignBuilder from "./../../components/campaign/CampaignBuilder";
import CreateCampaign from "./../../components/campaign/CreateCampaign";
import CampaignSummary from "./../../components/campaign/CampaignSummary";
import CampaignSuccess from "./../../components/campaign/CampaignSuccess";
import Forms from "./../../components/forms/Forms";
import FormBuilder from "./../../components/forms/FormBuilder";
import FormDomain from "./../../components/forms/FormDomain";
import LandingPages from "./../../components/landing_pages/LandingPage";
import LandingPageBuilder from "./../../components/landing_pages/LandingPageBuilder";
import LandingPageDomain from "./../../components/landing_pages/LandingPageDomain";
import Support from "./../../components/support/Support";
import List from "./../../components/list/List";
import Deals from "./../../components/deals/Deals";
import PublicPage from "./../../components/public_page/PublicPage";
import DealDetails from "./../../components/deals/DealDetails";
import Settings from "./../../components/settings/Settings";
import DealsUI from "./../../components/deals/deal_ui/DealsUI";
import ImportPortal from "./../../components/import_export/import";
import Automation from "./../../components/automation/Automation";
import TemplateSelection from "./../../components/common/TemplateSelection";
import LandingPageManager from "./../../components/landing_pages/LandingPageManager";
import FormManager from "./../../components/forms/FormManager";
import CampaignManager from "./../../components/campaign/CampaignManager";
import FunnelBuilder from "./../../components/funnel/FunnelBuilder";
import FunnelTypeSelection from "./../../components/funnel/FunnelTypeSelection";
import FunnelDomain from "./../../components/funnel/FunnelDomain";
import PayrollGrid from "./../../components/payroll/PayrollGrid";
import MyAttendance from "../../components/attendance/MyAttendance";
import TeamReport from "../../components/attendance/TeamReport";
import ProcessPayroll from "./../../components/payroll/ProcessPayrollPortal";
import PayrollSummary from "./../../components/payroll/PayrollSummary";
import PayrollSetup from "./../../components/payroll-setup/PayrollSetup";
import ComponentList from "./../../components/Component/ComponentList"
import EmployeeList from "./../../components/payroll-setup/EmployeeList";
import PayScheduleGrid from "./../../components/pay-schedule/PayScheduleGrid";
import AddEmployeePortal from "./../../components/add-employee/AddEmployeePortal";
import TerminateEmployee from "./../../components/employee/TerminationPortal";
import CustomFieldsList from "./../../components/custom-fields/CustomFieldsList";
import TaxDetails from "./../../components/compliance/in/tax-detail/TaxDetails";
import ic_dashboard from "../../assets/icons/navigation-icons/white/ic_dashboard.svg";
import ic_hiring from "../../assets/icons/navigation-icons/white/ic_hiring.svg";
import ic_payroll from "../../assets/icons/navigation-icons/white/ic_payroll.svg";
import ic_expense from "../../assets/icons/navigation-icons/white/ic_expense.svg";
import ic_timeoff from "../../assets/icons/navigation-icons/white/ic_timeoff.svg";
import ic_companysetting from "../../assets/icons/navigation-icons/white/ic_companysetting.svg";
import ic_reports from "../../assets/icons/navigation-icons/white/ic_reports.svg";
import ic_summarize from "../../assets/icons/navigation-icons/white/investments-icons.svg";
import ic_settings from "../../assets/icons/navigation-icons/white/ic_setting.svg";
import ic_automation from "../../assets/icons/navigation-icons/white/ic_automation.png";
import ic_performance from "../../assets/icons/navigation-icons/white/ic_performance.svg";
import shift_management from "../../assets/icons/navigation-icons/white/shift_management.svg";
import policy_n_resources from "../../assets/icons/navigation-icons/white/policy-n-resources.svg";


import ITDeclaration from "../../components/compliance/in/investment/ITDeclaration";
import Employees from "../../components/compliance/in/investment/Employees";
import { INVESTMENT_STAGE } from "../../components/compliance/in/investment/InvestmentConstants";
import MyITDeclaration from "../../components/compliance/in/investment/MyITDeclaration";
import { TENANT, TenantService } from "../TenantManagerService";
import ProofOfInvestment from "../../components/compliance/in/investment/ProofOfInvestment";
import MyActual from "../../components/compliance/in/investment/MyActual";
import MyApproval from "../../components/compliance/in/investment/MyApproval";
import ApiConstants from "../../constants/ApiConstants";
import BenefitsList from "../../components/benefits/BenefitsList";
import CompanyDetails from "../../components/CompanySetting/CompanyDetails";
import USTaxDetailsNew from "../../components/compliance/us/USTaxDetailsNew";
import ReportsList from "../../components/reports/ReportList";
import PayrollSummaryReport from "../../components/reports/compliance/SG/PayrollSummary";
import PayrollLiabilityReport from "../../components/reports/compliance/IN/PayrollLiability";
import W4FormsForEmployee from "../../components/reports/compliance/US/W4Forms";
import W2FormsForEmployee from "../../components/reports/compliance/US/W2Forms";
import W3FormsForEmployee from "../../components/reports/compliance/US/W3Forms";
import W9FormsForContractor from "../../components/reports/compliance/US/W9FormContractor";
import MISC1099 from "../../components/reports/compliance/US/1099MISC";
import NEC1099 from "../../components/reports/compliance/US/1099NEC";
import Form941 from "../../components/reports/compliance/US/Form941";
import Form944 from "../../components/reports/compliance/US/Form944";
import I9 from "../../components/reports/compliance/US/I9Form";
import {isMobileWebView, isViewportLarge} from "../../utility/ViewportSizeUtils";
import SideBarService from "../../services/sidebar";
import Contractor from "../../components/contractor/ContractorList";
import AddContractor from "../../components/contractor/AddContractor";
import ImportEmployeePortal from "../../components/employee/employee_import/EmployeePortal";
import IntegrationSettings from "../../components/integration-settings/IntegrationSettings";
import ViewEmployee from "../../components/employee/ViewEmployee";
import PayStubList from "../../components/payroll/PayStubList";
import paystub_icon from "../../assets/icons/navigation-icons/white/credit_card_white_24dp.svg";
import ComponentGroups from "../../components/component-groups/ComponentGroups";
import ImportLogGrid from "../../components/ImportLog/ImportLog";

import ContractorPayrunList from "../../components/contractor/contractor-payrun/ContractorPayrunList";
import PayslipDesign from "../../components/PayslipDesign/PayslipDesign";
import DefaultForm from "../../components/reports/compliance/US/DefaultForm";
import ContractorView from "../../components/contractor/Contractor-detail";
import ContractorSetting from "../../components/contractor/ContractorSetting";
import AutomationBuilder from "../../components/automation/AutomationBuilder";
import ExpenseIntegationSettings from "../../components/expense-integration-settings/ExpenseIntegrationSettings";
import ExpenseClaims from "../../components/expense/ExpenseClaims";
import ExpenseAdminSetting from "../../components/expense/expense-admin-setting/ExpenseAdminSetting";
import GroupUser from "../../components/expense/expense-admin-setting/GroupUser";
import CommissionReport from "../../components/automation/automation-reports/CommissionReport";
import WorkflowReport from "../../components/automation/automation-reports/WorkflowReport";
import ManageLocationList from "../../components/manage-location/ManageLocationList";
import StatutoryReport from "../../components/reports/compliance/IN/StatutoryReports/StatutoryReport";
import NotificationSetting from "../../components/notification-setting/NotificationSetting";
import AttendanceSetting from "../../components/attendance-setting/AttendanceSetting";
import i18next from "i18next";
import AttendancePortal from "../../components/attendance/import/AttendancePortal";
import SequenceNumberFormat from "../../components/SequenceNumberFormat/SequenceNumberFormat";
import AppraisalCycle from "../../components/performance/AppraisalCycle";
import SelfAssessment from "../../components/performance/SelfAssessment";
import AssessmentReview from "../../components/performance/AssessmentReview";
import AdminReview from "../../components/performance/AdminReview";
import AddCpfAccount from "../../components/AddCpfAccount";
import AddEpfAccount from "../../components/AddEpfAccount";
import PaymentMethod from "../../components/payroll/PaymentMethod";
import GiroGrid from "../../components/giro/Giro";
import MakePayment from "../../components/giro/MakePayment";
import MYTaxdetails from "../../components/compliance/my/MYTaxDetails";
import BankAccounts from "../../components/bank-account/BankAccounts";
import PaymentLogs from "../../components/payment-logs/PaymentLogs";
import CP39 from "../../components/reports/compliance/MY/CP39";
import SOCSOBorang8A from "../../components/reports/compliance/MY/SOCSOBorang8A";
import KWSPBorangA from "../../components/reports/compliance/MY/KWSPBorangA";
import SIP from "../../components/reports/compliance/MY/SIP";
import CP8D from "../../components/reports/compliance/MY/CP8D";
import EAForm from "../../components/reports/compliance/MY/EAForm";

import IRASSummaryReport from "../../components/reports/compliance/SG/IRASSummaryReport";
import SGDefaultForms from "../../components/reports/compliance/SG/SGDefaultForms";
import AISSubmission from "../../components/reports/compliance/SG/ais_submission/AISSubmission";
import IRASSettings from "../../components/reports/compliance/SG/IRASSettings";
import ProxyAISSubmission from "../../components/reports/compliance/SG/ais_submission/ProxyAISSubmission";
import Notifications from "../../components/notification/Notification";
import Shifts from "../../components/shift_management/Shifts";
import ShiftMembers from "../../components/shift_management/ShiftMembers";
import AssignMembers from "../../components/shift_management/AssignMembers";
import UserTaxDetails from "../../components/compliance/my/UserTaxDetails";
import OvertimeList from "../../components/overtime/OvertimeList";
import OvertimeGeneralSetting from "../../components/overtime/OvertimeGeneralSetting";
import OvertimeSummary from "../../components/overtime/OvertimeSummary";
import OvertimeRateConfiguration from "../../components/overtime/OvertimeRateConfiguration";
import { getDefaultPayslipUUID, isProfessionalPlan, showUpgradePlanAlert, showAccessDeniedAlert, showBooksAccessAlert } from "./CommonUtil";
import ConfigureCompOff from "../../components/compensatoryOff/ConfigureCompoff";
import ManageCompOff from "../../components/compensatoryOff/ManageCompOff";
import ManageCompOffRequest from "../../components/compensatoryOff/ManageCompOffRequest";
import AppliedCompOff from "../../components/compensatoryOff/AppliedCompOffs";
import FillingAuthorization from "../../components/compliance/us/FillingAuthorization";
import SignForm from "../../components/compliance/us/SignForm";
import AddShift from "../../components/shift_management/AddShift";
import UserManager from "../UserManager";
import { isUSStateComplianceEnabled } from "../../components/compliance/us/ConstantsUS";
import EmailTemplatelist from "../../components/email-template/EmailTemplatelist";
import AuditLogs from "../../components/audit-logs/AuditLogs";
import BiometricIntegrationSettings from "../../components/biometric_attendance/BiometricIntegrationSettings";
import ComponentValueImportPortal from "../../components/Component/import/ComponentValueImportPortal";
import Utility from "../../utility/Utility";
import Tenant from "../../services/tenant";
import { showLoader, removeLoader} from "deskera-ui-library";
import TimesheetEntry from "../../components/timesheet/timesheet-entry/TimesheetEntry";
import Projects from "../../components/timesheet/projects/Projects";
import EmployeeMapping from "../../components/timesheet/employee-mapping/EmployeeMapping";
import TimesheetReport from "../../components/timesheet/reports/TimesheetReport";
import Tasks from "../../components/timesheet/tasks/Tasks";
import PermissionUtils, { ACTION, MODULE } from "../../components/user-permissions/PermissionUtils";
import TimesheetReportList from "../../components/timesheet/reports/TimesheetReportList";
import TimesheetReportCalendarView from "../../components/timesheet/reports/TimesheetReportCalendarView";
import TimesheetReportGrouping from "../../components/timesheet/reports/TimesheetReportGrouping";
import WageRegisterReport from "../../components/reports/compliance/IN/WageRegister";
import Form16 from "../../components/reports/compliance/IN/Form16";
import Goals from "../../components/performance/Goals";
import AppraisalCycleList from "../../components/performance/AppraisalCycleList";
import CreateAppraisalCycleStepper from "../../components/performance/CreateAppraisalCycleStepper";
import PolicyAndResources from "../../components/policy-and-resources/PolicyAndResources";

export const ADMIN = "A";
export const EMPLOYEE = "E";
export const ADMIN_EMPLOYEE = "AE";
export const CONTRACTOR = "C";
export const HIRING_ADMIN = "HR";
export const EMPLOYEE_HIRING_ADMIN = "EHR";
export const ADMIN_HIRING_ADMIN = "AHR";
export const ADMIN_EMPLOYEE_HIRING_ADMIN = "AEHR";
export const OWNER = "O";
export const OWNER_ADMIN = "OA";
export const OWNER_ADMIN_HIRING_ADMIN = "OAHR";
export const OWNER_ADMIN_EMPLOYEE_HIRING_ADMIN = "OAEHR";
export const OWNER_HIRING_ADMIN = "OHR";
export const OWNER_ADMIN_MANAGER = 'OAM';

const getAuthDetails = (componentName) => {
    const auth = {
        accessLevel: "rwd"
    };

    switch (componentName) {
        default:
            auth.accessLevel = "rwd";
            break;
    }

    return auth;
}

export const ROUTES = [
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: "/",
    render: (props) => (
      <Dashboard {...getAuthDetails("DASHBOARD")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    accessToModule: MODULE.CANDIDATE,
    country: ["-1"],
    route: "/candidate",
    render: (props) => <Contacts {...getAuthDetails("CANDIDATE")} {...props} />,
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/import-portal",
    accessToModule: MODULE.CANDIDATE,
    render: (props) => (
      <ImportPortal {...getAuthDetails("IMPORT_PORTAL")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    accessToModule: MODULE.CANDIDATE,
    country: ["-1"],
    route: "/Job-opening",
    render: (props) => <List {...getAuthDetails("JOB_OPENING")} {...props} />,
  },
  {
    accessTo: "OAHR",
    accessToModule: MODULE.JOB_PIPELINE,
    country: ["-1"],
    route: "/job-pipeline",
    render: (props) => <Deals {...getAuthDetails("JOB_PIPELINE")} {...props} />,
  },
  {
    accessTo: "OAHR",
    accessToModule: MODULE.JOB_PIPELINE,
    country: ["-1"],
    route: "/deal-details/:id",
    render: (props) => (
      <DealDetails {...getAuthDetails("DEAL_DETAILS")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/funnel",
    render: (props) => <Funnel {...getAuthDetails("FUNNEL")} {...props} />,
  },
  {
    accessTo: "OHR",
    country: ["-1"],
    route: "/funnel-builder",
    render: (props) => (
      <FunnelBuilder {...getAuthDetails("FUNNEL_BUILDER")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/funnel-selection",
    render: (props) => (
      <FunnelTypeSelection {...getAuthDetails("FUNNEL_SELECTION")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/funnel-domain",
    render: (props) => (
      <FunnelDomain {...getAuthDetails("FUNNEL_DOMAIN")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/funnel-builder/:id",
    render: (props) => (
      <FunnelBuilder {...getAuthDetails("FUNNEL_BUILDER_ID")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/funnel-domain/:id",
    render: (props) => (
      <FunnelDomain {...getAuthDetails("FUNNEL_DOMAIN_ID")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/automation",
    accessToModule: MODULE.AUTOMATION,
    render: (props) => (
      <Automation
        {...getAuthDetails("AUTOMATION")}
        {...props}
        showBanner={true}
      />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/campaign",
    render: (props) => <Campaign {...getAuthDetails("CAMPAIGN")} {...props} />,
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/create-campaign",
    render: (props) => (
      <CreateCampaign {...getAuthDetails("CREATE_CAMPAIGN")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/select-campaign-template",
    render: (props) => (
      <TemplateSelection
        {...getAuthDetails("SELECT_CAMPAIGN_TEMPLATE")}
        manager={CampaignManager}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/campaign-summary",
    render: (props) => (
      <CampaignSummary {...getAuthDetails("CAMPAIGN_SUMMARY")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/campaign-success",
    render: (props) => (
      <CampaignSuccess {...getAuthDetails("CAMPAIGN_SUCCESS")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/campaign-builder",
    render: (props) => (
      <CampaignBuilder {...getAuthDetails("CAMPAIGN_BUILDER")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/select-campaign-template/:id",
    render: (props) => (
      <TemplateSelection
        {...getAuthDetails("SELECT_CAMPAIGN_TEMPLATE_ID")}
        manager={CampaignManager}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/campaign-summary/:id",
    render: (props) => (
      <CampaignSummary {...getAuthDetails("CAMPAIGN_SUMMARY_ID")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/campaign-success/:id",
    render: (props) => (
      <CampaignSuccess {...getAuthDetails("CAMPAIGN_SUCCESS_ID")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/campaign-builder/:id",
    render: (props) => (
      <CampaignBuilder {...getAuthDetails("CAMPAIGN_BUILDER_ID")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    accessToModule: MODULE.JOB_FORM,
    country: ["-1"],
    route: "/job-forms",
    render: (props) => <Forms {...getAuthDetails("JOB_FORMS")} {...props} />,
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/select-form-template",
    accessToModule: MODULE.JOB_FORM,
    render: (props) => (
      <TemplateSelection
        {...getAuthDetails("SELECT_FORM_TEMPLATE")}
        manager={FormManager}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/form-builder",
    accessToModule: MODULE.JOB_FORM,
    render: (props) => (
      <FormBuilder {...getAuthDetails("FORM_BUILDER")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/form-domain",
    accessToModule: MODULE.JOB_FORM,
    render: (props) => (
      <FormDomain {...getAuthDetails("FORM_DOMAIN")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/select-form-template/:id",
    accessToModule: MODULE.JOB_FORM,
    render: (props) => (
      <TemplateSelection
        {...getAuthDetails("SELECT_FORM_TEMPLATE_ID")}
        manager={FormManager}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/form-builder/:id",
    accessToModule: MODULE.JOB_FORM,
    render: (props) => (
      <FormBuilder {...getAuthDetails("FORM_BUILDER_ID")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/form-domain/:id",
    accessToModule: MODULE.JOB_FORM,
    render: (props) => (
      <FormDomain {...getAuthDetails("FORM_DOMAIN_ID")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/landing-pages",
    accessToModule: MODULE.JOB_FORM,
    render: (props) => (
      <LandingPages {...getAuthDetails("LANDING_PAGE")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/select-email-template",
    render: (props) => (
      <TemplateSelection
        {...getAuthDetails("SELECT_LANDING_PAGE_TEMPLATE")}
        manager={LandingPageManager}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/email-template-builder",
    render: (props) => (
      <LandingPageBuilder
        {...getAuthDetails("LANDING_PAGE_BUILDER")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/email-template-domain",
    render: (props) => (
      <LandingPageDomain
        {...getAuthDetails("LANDING_PAGE_DOMAIN")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/select-email-template/:id",
    render: (props) => (
      <TemplateSelection
        {...getAuthDetails("SELECT_LANDING_PAGE_TEMPLATE_ID")}
        manager={LandingPageManager}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/email-template-builder/:id",
    render: (props) => (
      <LandingPageBuilder
        {...getAuthDetails("LANDING_PAGE_BUILDER_ID")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAHR",
    country: ["-1"],
    route: "/email-template-domain/:id",
    render: (props) => (
      <LandingPageDomain
        {...getAuthDetails("LANDING_PAGE_DOMAIN_ID")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: "/public/:id",
    render: (props) => (
      <PublicPage {...getAuthDetails("PUBLIC_PAGE")} {...props} />
    ),
  },
  {
    accessTo: "OAHR",
    accessToModule: MODULE.CANDIDATE,
    country: ["-1"],
    route: "/candidate/:id",
    render: (props) => (
      <DealsUI {...getAuthDetails("CANDIDATE_UI")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/pay-schedule",
    accessToModule: MODULE.PAY_SCHEDULE,
    render: (props) => (
      <PayScheduleGrid {...getAuthDetails("PAY_SCHEDULE_LIST")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/payrolls",
    accessToModule: [MODULE.PAYRUN, MODULE.SALARY],
    hasEachAccess: true,
    render: (props) => (
      <PayrollGrid {...getAuthDetails("PAYROLL_GRID")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/process-payroll/",
    accessToModule: [MODULE.PAYRUN, MODULE.CONTRACTOR_PAYRUN],
    render: (props) => (
      <ProcessPayroll {...getAuthDetails("PROCESS_PAYROLL")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/process-summary",
    accessToModule: [MODULE.PAYRUN, MODULE.CONTRACTOR_PAYRUN],
    render: (props) => (
      <PayrollSummary {...getAuthDetails("PROCESS_SUMMARY")} {...props} />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: "/my-attendance",
    // accessToModule: MODULE.MY_ATTENDANCE,
    render: (props) => (
      <MyAttendance {...getAuthDetails("MY_ATTENDANCE")} {...props} />
    ),
  },
  {
    accessTo: "OAM",
    country: ["-1"],
    route: "/team-attendance",
    accessToModule: MODULE.TEAM_REPORT,
    render: (props) => (
      <TeamReport {...getAuthDetails("TEAM_ATTENDANCE")} {...props} />
    ),
  },
  {
    accessTo: "OAM",
    country: ["-1"],
    accessToModule: MODULE.TEAM_REPORT,
    route: "/team-attendance/",
    render: (props) => (
      <TeamReport {...getAuthDetails("TEAM_ATTENDANCE")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/employee",
    accessToModule: MODULE.EMPLOYEE,
    render: (props) => (
      <EmployeeList
        {...getAuthDetails("EMPLOYEE_LIST")}
        isActionEnabled={false}
        isFromEmployeeSetup={false}
        {...props}
      />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/component",
    accessToModule: MODULE.EARNINGS_AND_DEDUCTIONS,
    render: (props) => (
      <ComponentList {...getAuthDetails("COMPONENT")} {...props} />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: "/employee-details/",
    accessToModule: MODULE.EMPLOYEE,
    render: (props) => (
      <AddEmployeePortal {...getAuthDetails("EMPLOYEE_DETAILS")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: "/investments/it-declaration",
    accessToModule: MODULE.IT_DECLARATION,
    render: (props) => (
      <ITDeclaration {...getAuthDetails("IT_DECLARATION")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: "/investments/employees-declaration",
    accessToModule: MODULE.EMPLOYEE_DECLARATION,
    render: (props) => (
      <Employees
        stage={INVESTMENT_STAGE.DECLARATION}
        {...getAuthDetails("EMPLOYEES_DECLARATION")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["IN"],
    route: "/investments/my-it-declaration",
    render: (props) => (
      <MyITDeclaration
        userId={TenantService.get(TENANT.USER_ID)}
        {...getAuthDetails("MY_IT_DECLARATION")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: "/investments/employee-it-declaration",
    accessToModule: MODULE.EMPLOYEE_DECLARATION,
    render: (props) => (
      <MyITDeclaration
        {...getAuthDetails("EMPLOYEE_IT_DECLARATION")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: "/investments/poi",
    accessToModule: MODULE.POI,
    render: (props) => (
      <ProofOfInvestment {...getAuthDetails("POI")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: "/investments/employees-poi",
    accessToModule: MODULE.EMPLOYEE_POI,
    render: (props) => (
      <Employees
        stage={INVESTMENT_STAGE.ACTUAL}
        {...getAuthDetails("EMPLOYEES_POI")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["IN"],
    route: "/investments/my-poi",
    render: (props) => (
      <MyActual
        userId={TenantService.get(TENANT.USER_ID)}
        {...getAuthDetails("MY_POI")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: "/investments/employee-poi",
    accessToModule: MODULE.EMPLOYEE_POI,
    render: (props) => <MyActual {...getAuthDetails("MY_POI")} {...props} />,
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: "/investments/employees-approval",
    accessToModule: MODULE.EMPLOYEE_APPROVAL,
    render: (props) => (
      <Employees
        stage={INVESTMENT_STAGE.APPROVED}
        {...getAuthDetails("EMPLOYEES_APPROVAL")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: "/investments/my-approval",
    render: (props) => (
      <MyApproval
        userId={TenantService.get(TENANT.USER_ID)}
        {...getAuthDetails("MY_APPROVAL")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: "/investments/employee-approval",
    accessToModule: MODULE.EMPLOYEE_APPROVAL,
    render: (props) => (
      <MyApproval {...getAuthDetails("MY_APPROVAL")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/custom-fields",
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <CustomFieldsList {...getAuthDetails("CUSTOM_FIELDS")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/integration-settings",
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <IntegrationSettings
        {...getAuthDetails("INTEGRATION_SETTINGS")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/component-groups",
    accessToModule: MODULE.EARNING_DEDUCTION_TEMPLETE,
    render: (props) => (
      <ComponentGroups {...getAuthDetails("COMPONENT_GROUPS")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/terminate-employee/",
    accessToModule: MODULE.EMPLOYEE,
    render: (props) => (
      <TerminateEmployee {...getAuthDetails("TERMINATE_EMPLOYEE")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: "/in/tax-details",
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <TaxDetails {...getAuthDetails("IN_TAX_DETAILS")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["MY"],
    route: PAGE_ROUTES.MY_TAX_DETAILS,
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <MYTaxdetails {...getAuthDetails("MY_TAX_DETAILS")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/payroll-setup",
    render: (props) => (
      <PayrollSetup {...getAuthDetails("PAYROLL_SETUP")} {...props} />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: "/support",
    render: (props) => <Support {...getAuthDetails("SUPPORT")} {...props} />,
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/settings",
    render: (props) => <Settings {...getAuthDetails("SETTINGS")} {...props} />,
  },
  {
    accessTo: "OA",
    country: ["US"],
    accessToModule: MODULE.BENEFITS,
    route: PAGE_ROUTES.BENEFITS,
    render: (props) => (
      <BenefitsList {...getAuthDetails("BENEFITS")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.COMPANY_DETAILS,
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <CompanyDetails {...getAuthDetails("COMPANY_DETAILS")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["US"],
    route: PAGE_ROUTES.US_TAX,
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <USTaxDetailsNew {...getAuthDetails("US_TAX_DETAILS")} {...props} />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: PAGE_ROUTES.REPORTS_LIST,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <ReportsList {...getAuthDetails("REPORT_LIST")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.REPORT.SG.PAYROLL_SUMMARY,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <PayrollSummaryReport {...getAuthDetails("PAYROLL_SUMMARY")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.REPORT.IN.PAYROLL_LIABILITY,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <PayrollLiabilityReport
        {...getAuthDetails("PAYROLL_LIABILITY")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["US"],
    route: PAGE_ROUTES.REPORT.US.W4_FORM,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <W4FormsForEmployee {...getAuthDetails("W4_FORM")} {...props} />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["US"],
    route: PAGE_ROUTES.REPORT.US.W2_FORM,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <W2FormsForEmployee {...getAuthDetails("W2_FORM")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["US"],
    route: PAGE_ROUTES.REPORT.US.W3_FORM,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <W3FormsForEmployee {...getAuthDetails("W3_FORM")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["US"],
    route: PAGE_ROUTES.REPORT.US.W9_FORM,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <W9FormsForContractor {...getAuthDetails("W9_FORM")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["US"],
    route: PAGE_ROUTES.REPORT.US.MISC1099,
    accessToModule: MODULE.REPORTS,
    render: (props) => <MISC1099 {...getAuthDetails("MISC1099")} {...props} />,
  },
  {
    accessTo: "OA",
    country: ["US"],
    route: PAGE_ROUTES.REPORT.US.NEC1099,
    accessToModule: MODULE.REPORTS,
    render: (props) => <NEC1099 {...getAuthDetails("NEC1099")} {...props} />,
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: "/employee-view/",
    render: (props) => (
      <ViewEmployee {...getAuthDetails("EMPLOYEE_VIEW")} {...props} />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: PAGE_ROUTES.CONTRACTOR_VIEW + "/",
    render: (props) => (
      <ContractorView {...getAuthDetails("CONTRACTOR_VIEW")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["US"],
    route: PAGE_ROUTES.REPORT.US.FORM941,
    accessToModule: MODULE.REPORTS,
    render: (props) => <Form941 {...getAuthDetails("Form941")} {...props} />,
  },
  {
    accessTo: "OA",
    country: ["US"],
    route: PAGE_ROUTES.REPORT.US.FORM944,
    accessToModule: MODULE.REPORTS,
    render: (props) => <Form944 {...getAuthDetails("Form944")} {...props} />,
  },
  {
    accessTo: "OAEHR",
    country: ["US"],
    route: PAGE_ROUTES.REPORT.US.I9,
    accessToModule: MODULE.REPORTS,
    render: (props) => <I9 {...getAuthDetails("I9")} {...props} />,
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.CONTRACTOR_LIST,
    accessToModule: MODULE.CONTRACTOR,
    render: (props) => (
      <Contractor {...getAuthDetails("CONTRACTOR")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.CONTRACTOR_DETAILS,
    accessToModule: MODULE.CONTRACTOR,
    render: (props) => (
      <AddContractor {...getAuthDetails("ADD_CONTRACTOR")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.IMPORT_EMPLOYEE,
    accessToModule: MODULE.EMPLOYEE,
    render: (props) => (
      <ImportEmployeePortal {...getAuthDetails("IMPORT_PORTAL")} {...props} />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: PAGE_ROUTES.PAYSTUB_LIST,
    accessToModule: MODULE.PAYSTUB,
    render: (props) => (
      <PayStubList {...getAuthDetails("PAYSTUB_LIST")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.CONTRACTOR_PAYRUN_LIST,
    accessToModule: [MODULE.CONTRACTOR_PAYRUN, MODULE.SALARY],
    hasEachAccess: true,
    render: (props) => (
      <ContractorPayrunList
        {...getAuthDetails("CONTRACTOR_PAYRUN")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OA",
    country: ["MY", "SG"],
    route: PAGE_ROUTES.GIRO,
    accessToModule: MODULE.GIRO,
    render: (props) => (
      <GiroGrid {...getAuthDetails("GIRO")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["MY", "SG"],
    route: PAGE_ROUTES.GIRO_MAKE_PAYMENT + '/:id',
    accessToModule: MODULE.GIRO,
    render: (props) => (
      <MakePayment {...getAuthDetails("GIRO_MAKE_PAYMENT")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.IMPORT_LOG,
    accessToModule: MODULE.IMPORT_LOG,
    render: (props) => (
      <ImportLogGrid {...getAuthDetails("IMPORT_LOG")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.PAYSLIP_DESIGN,
    render: (props) => (
      <PayslipDesign {...getAuthDetails("PAYSLIP_DESIGN")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["US"],
    route: PAGE_ROUTES.REPORT.US.FORM,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <DefaultForm {...getAuthDetails("DEFAULT_FORM")} {...props} />
    ),
  },
  {
    accessTo: "C",
    country: ["-1"],
    route: PAGE_ROUTES.CONTRACTOR_SETTING,
    render: (props) => (
      <ContractorSetting {...getAuthDetails("CONTRACTOR_SETTING")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    accessToModule: MODULE.AUTOMATION,
    route: PAGE_ROUTES.AUTOMATION_BUILDER,
    render: (props) => (
      <AutomationBuilder {...getAuthDetails("AUTOMATION_BUILDER")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    accessToModule: MODULE.AUTOMATION,
    route: PAGE_ROUTES.AUTOMATION_BUILDER + "/:id",
    render: (props) => (
      <AutomationBuilder {...getAuthDetails("AUTOMATION_BUILDER")} {...props} />
    ),
  },
  {
    accessTo: "C",
    country: ["-1"],
    route: PAGE_ROUTES.CONTRACTOR_SETTING,
    render: (props) => (
      <ContractorSetting {...getAuthDetails("CONTRACTOR_SETTING")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.REPORT.AUTOMATION.WORKFLOW,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <WorkflowReport {...getAuthDetails("WORKFLOW_REPORT")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    accessToModule: MODULE.AUTOMATION,
    route: PAGE_ROUTES.REPORT.AUTOMATION.WORKFLOW + "/:id",
    render: (props) => (
      <WorkflowReport {...getAuthDetails("WORKFLOW_REPORT")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    accessToModule: MODULE.AUTOMATION,
    route: PAGE_ROUTES.REPORT.AUTOMATION.COMMISSION,
    render: (props) => (
      <CommissionReport {...getAuthDetails("COMMISSION_REPORT")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    accessToModule: MODULE.AUTOMATION,
    route: PAGE_ROUTES.REPORT.AUTOMATION.COMMISSION + "/:id",
    render: (props) => (
      <CommissionReport {...getAuthDetails("COMMISSION_REPORT")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.EXPENSE.EXPENSE_INTEGARTION_SETTINGS,
    accessToModule: MODULE.EXPENSE_INTEGRATION_SETTING,
    render: (props) => (
      <ExpenseIntegationSettings
        {...getAuthDetails("EXPENSE_INTEGRATION_SETTINGS")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: PAGE_ROUTES.EXPENSE.EXPENSE_CLAIM,
    accessToModule: MODULE.EXPENSE_CLAIM,
    render: (props) => (
      <ExpenseClaims {...getAuthDetails("EXPENSE_CLAIMS")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.EXPENSE.EXPENSE_ADMIN_SETTING,
    accessToModule: MODULE.EXPENSE_ADMIN_SETTING,
    render: (props) => (
      <ExpenseAdminSetting
        {...getAuthDetails("EXPENSE_ADMIN_SETTING")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.EXPENSE.EXPENSE_GROUP_USER,
    accessToModule: MODULE.EXPENSE_ADMIN_SETTING,
    render: (props) => (
      <GroupUser {...getAuthDetails("EXPENSE_GROUP_USER")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.EXPENSE.EXPENSE_GROUP_USER + "/:id/:name",
    accessToModule: MODULE.EXPENSE_ADMIN_SETTING,
    render: (props) => (
      <GroupUser {...getAuthDetails("EXPENSE_GROUP_USER")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.MANAGE_LOCATION,
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <ManageLocationList {...getAuthDetails("MANAGE_LOCATION")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: PAGE_ROUTES.REPORT.STATUTORY_REPORTS.PROFESSIONAL_TAX + "/:form",
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <StatutoryReport {...getAuthDetails("PROFESSION_TAX")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.NOTIFICATION_SETTING,
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <NotificationSetting
        {...getAuthDetails("NOTIFICATION_SETTING")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.ATTENDANCE_SETTING,
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <AttendanceSetting {...getAuthDetails("ATTENDANCE_SETTING")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.IMPORT_ATTENDANCE,
    accessToModule: MODULE.TEAM_REPORT,
    render: (props) => (
      <AttendancePortal
        {...getAuthDetails("ATTENDANCE_IMPORT_PORTAL")}
        {...props}
      />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.SEQUENCE_FORMAT,
    render: (props) => <SequenceNumberFormat{...props} />
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.APPRAISAL_CYCLE,
    render: (props) => (
      <AppraisalCycle {...getAuthDetails("APPRAISAL_CYCLE")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.APPRAISAL_CYCLE_LIST,
    accessToModule: MODULE.PERFORMANCE_APPRAISAL_CYCLE,
    render: (props) => (
      <AppraisalCycleList {...getAuthDetails("APPRAISAL_CYCLE_LIST")} {...props} />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: PAGE_ROUTES.SELF_ASSESSMENT,
    render: (props) => (
      <SelfAssessment {...getAuthDetails("SELF_ASSESSMENT")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.ASSESSMENT_REVIEW,
    render: (props) => (
      <AssessmentReview {...getAuthDetails("ASSESSMENT_REVIEW")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.ADMIN_REVIEW,
    render: (props) => (
      <AdminReview {...getAuthDetails("ADMIN_REVIEW")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["SG"],
    route: PAGE_ROUTES.ADD_CPF_ACCOUNT,
    render: (props) => (
      <AddCpfAccount {...getAuthDetails("ADD_CPF_ACCOUNT")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["MY"],
    route: PAGE_ROUTES.ADD_EPF_ACCOUNT,
    render: (props) => (
      <AddEpfAccount {...getAuthDetails("ADD_EPF_ACCOUNT")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/payment-method/",
    render: (props) => (
      <PaymentMethod {...getAuthDetails("PAYMENT_METHOD")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["SG", "MY", "US"],
    route: PAGE_ROUTES.BANK_ACCOUNTS,
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <BankAccounts {...getAuthDetails("BANK_ACCOUNTS")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["SG", "MY"],
    route: PAGE_ROUTES.PAYMENT_LOGS,
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <PaymentLogs {...getAuthDetails("PAYMENT_LOGS")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: "/payment-method/",
    render: (props) => (
      <PaymentMethod {...getAuthDetails("PAYMENT_METHOD")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["MY"],
    route: PAGE_ROUTES.REPORT.MY.CP39,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <CP39 {...getAuthDetails("CP39")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["MY"],
    route: PAGE_ROUTES.REPORT.MY.SOCSOBorang8A,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <SOCSOBorang8A {...getAuthDetails("SOCSOBorang8A")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["MY"],
    route: PAGE_ROUTES.REPORT.MY.KWSPBorangA,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <KWSPBorangA {...getAuthDetails("KWSPBorangA")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["MY"],
    route: PAGE_ROUTES.REPORT.MY.SIP,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <SIP {...getAuthDetails("SIP")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["MY"],
    route: PAGE_ROUTES.REPORT.MY.CP8D,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <CP8D {...getAuthDetails("CP8D")} {...props} />
    ),
  }
  ,
  {
    accessTo: "OA",
    country: ["SG"],
    route: PAGE_ROUTES.REPORT.SG.IRAS_SUMMARY_REPORT,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <IRASSummaryReport {...getAuthDetails("CP8D")} {...props} />
    ),

  },
  {
    accessTo: "OA",
    country: ["MY"],
    route: PAGE_ROUTES.REPORT.MY.EAForm,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <EAForm {...getAuthDetails("EAForm")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["SG"],
    route: PAGE_ROUTES.REPORT.SG.FORM,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <SGDefaultForms {...getAuthDetails("CPF_SUBMISSION")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["SG"],
    route: PAGE_ROUTES.REPORT.SG.IRAS_AIS_SUBMISSION,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <AISSubmission {...getAuthDetails("IRAS_AIS_SUBMISSION")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["SG"],
    route: PAGE_ROUTES.REPORT.SG.IRAS_SETTINGS,
    accessToModule: [MODULE.REPORTS, MODULE.COMPANY_SETTINGS],
    render: (props) => (
      <IRASSettings {...getAuthDetails("IRAS_SETTINGS")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["SG"],
    route: PAGE_ROUTES.REPORT.SG.IRAS_CALL_BACK,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <ProxyAISSubmission {...getAuthDetails("IRAS_CALL_BACK")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.NOTIFICATIONS,
    render: (props) => (
      <Notifications {...getAuthDetails("NOTIFICATIONS")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.SHIFTS,
    accessToModule: MODULE.SHIFT,
    render: (props) => (
      <Shifts {...getAuthDetails("SHIFTS")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.ADD_SHIFT,
    accessToModule: MODULE.SHIFT,
    render: (props) => (
      <AddShift {...getAuthDetails("ADD_SHIFT")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.SHIFT_MEMBERS,
    accessToModule: MODULE.SHIFT_ASSIGNMENT,
    render: (props) => (
      <ShiftMembers {...getAuthDetails("SHIFT_MEMBERS")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.ASSIGN_MEMBERS,
    accessToModule: MODULE.SHIFT_ASSIGNMENT,
    render: (props) => (
      <AssignMembers {...getAuthDetails("ASSIGN_MEMBERS")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.MY_USER_TAX_DETAILS,
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <UserTaxDetails {...getAuthDetails("MY_USER_TAX_DETAILS")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.OVERTIME_LIST,
    accessToModule: MODULE.OVERTIME_POLICY,
    render: (props) => (
      <OvertimeList {...getAuthDetails("OVERTIME_LIST")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.OVERTIME_SETTING,
    accessToModule: MODULE.OVERTIME_POLICY,
    render: (props) => (
      <OvertimeGeneralSetting {...getAuthDetails("OVERTIME_SETTING")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.OVERTIME_SETTING+"/:id",
    accessToModule: MODULE.OVERTIME_POLICY,
    render: (props) => (
      <OvertimeGeneralSetting {...getAuthDetails("OVERTIME_SETTING")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.OVERTIME_SUMMARY,
    accessToModule: MODULE.OVERTIME_POLICY,
    render: (props) => (
      <OvertimeSummary {...getAuthDetails("OVERTIME_SUMMARY")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.OVERTIME_SUMMARY+"/:id",
    accessToModule: MODULE.OVERTIME_POLICY,
    render: (props) => (
      <OvertimeSummary {...getAuthDetails("OVERTIME_SUMMARY")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.OVERTIME_RATE_CONFIG,
    accessToModule:MODULE.OT_MULTIPLIER,
    render: (props) => (
      <OvertimeRateConfiguration {...getAuthDetails("OVERTIME_RATE_CONFIG")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.COMP_OFF.CONFIGURE_COMP_OFF,
    accessToModule: MODULE.COMP_OFF_CONFIGURATION,
    render: (props) => (
      <ConfigureCompOff {...getAuthDetails("CONFIGURE_COMP_OFF")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.COMP_OFF.MANAGE_COMP_OFF,
    accessToModule: MODULE.MANAGE_COMP_OFF,
    render: (props) => (
      <ManageCompOff {...getAuthDetails("MANAGE_COMP_OFF")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.COMP_OFF.MANAGE_REQUEST,
    accessToModule: MODULE.MANAGE_COMP_OFF_REQUEST,
    render: (props) => (
      <ManageCompOffRequest {...getAuthDetails("MANAGE_REQUEST")} {...props} />
    )
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: PAGE_ROUTES.COMP_OFF.MY_COMP_OFF,
    accessToModule: MODULE.MY_COMP_OFF,
    render: (props) => (
      <AppliedCompOff {...getAuthDetails("MY_COMP_OFF")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["US"],
    route: PAGE_ROUTES.FILLING_AUTHORIZATION,
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <FillingAuthorization {...getAuthDetails("FILLING_AUTHORIZATION")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["US"],
    route: PAGE_ROUTES.SIGN_FORM,
    accessToModule: MODULE.COMPANY_SETTINGS,
    render: (props) => (
      <SignForm {...getAuthDetails("SIGN_FORM")} {...props} />
      )
  },
  {
    accessTo:"OAHR",
    country: ["-1"],
    accessToModule: MODULE.EMAIL_TEMPLATE,
    route: PAGE_ROUTES.EMAIL_TEMPLATE.LIST,
    render:(props) => (
      <EmailTemplatelist {...getAuthDetails("EMAIL_TEMPLATE_LIST")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.AUDIT_LOGS,
    render: (props) => (
      <AuditLogs {...getAuthDetails("AUDIT_LOGS")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.BIOMETRIC_ATTENDANCE_SETUP,
    accessToModule: MODULE.BIO_ATTENDANCE_SETTING,
    render: (props) => (
      <BiometricIntegrationSettings {...getAuthDetails("BIOMETRIC_ATTENDANCE_SETUP")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.IMPORT_COMPONENT_VALUES,
    accessToModule: MODULE.EARNINGS_AND_DEDUCTIONS,
    render: (props) => (
      <ComponentValueImportPortal {...getAuthDetails("IMPORT_COMPONENT_VALUES")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.PROJECTS,
    accessToModule: MODULE.TIMESHEET,
    render: (props) => (
      <Projects {...getAuthDetails("PROJECTS")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.TASKS,
    accessToModule: MODULE.TIMESHEET,
    render: (props) => (
      <Tasks {...getAuthDetails("TASKS")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.EMPLOYEE_MAPPING,
    accessToModule: MODULE.TIMESHEET,
    render: (props) => (
      <EmployeeMapping {...getAuthDetails("EMPLOYEE_MAPPING")} {...props} />
    )
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: PAGE_ROUTES.TIMESHEET_ENTRY,
    accessToModule: MODULE.TIMESHEET,
    render: (props) => (
      <TimesheetEntry {...getAuthDetails("TIMESHEET_ENTRY")} {...props} permissions={{}} />
    )
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: PAGE_ROUTES.TIMESHEET_REPORT_LIST,
    accessToModule: MODULE.TIMESHEET,
    render: (props) => (
      <TimesheetReportList {...getAuthDetails("TIMESHEET_REPORTS")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.TIMESHEET_REPORT,
    accessToModule: MODULE.TIMESHEET,
    render: (props) => (
      <TimesheetReport {...getAuthDetails("TIMESHEET_REPORT")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.TIMESHEET_REPORT_GROUP,
    accessToModule: MODULE.TIMESHEET,
    render: (props) => (
      <TimesheetReportGrouping {...getAuthDetails("TIMESHEET_REPORT_GROUP")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.TIMESHEET_REPORT_CALENDAR,
    accessToModule: MODULE.TIMESHEET,
    render: (props) => (
      <TimesheetReportCalendarView {...getAuthDetails("ADMIN_TIMESHEET_REPORT_CALENDAR")} {...props} />
    )
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: PAGE_ROUTES.REPORT.STATUTORY_REPORTS.WAGE_REGISTER,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <WageRegisterReport {...getAuthDetails("WAGE_REGISTER")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["IN"],
    route: PAGE_ROUTES.REPORT.IN.FORM16,
    accessToModule: MODULE.REPORTS,
    render: (props) => (
      <Form16 {...getAuthDetails("FORM16")} {...props} />
    ),
  },
  {
    accessTo: "OA",
    country: ["-1"],
    route: PAGE_ROUTES.APPRAISAL_CYCLE_STEP,
    accessToModule: MODULE.PERFORMANCE_APPRAISAL_CYCLE,
    render: (props) => (
      <CreateAppraisalCycleStepper {...getAuthDetails("APPRAISAL_CYCLE_STEP")} {...props} />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: PAGE_ROUTES.PERFORMANCE.GOAL,
    render: (props) => (
      <Goals {...getAuthDetails("GOAL")} {...props} />
    ),
  },
  {
    accessTo: "OAEHR",
    country: ["-1"],
    route: PAGE_ROUTES.POLICY_AND_RESOURCES.LIST,
    accessToModule: MODULE.POLICY_AND_RESOURCES,
    render: (props) => (
      <PolicyAndResources {...getAuthDetails("POLICY_AND_RESOURCES_LIST")} {...props} />
    ),
  }
];

export const NAVIGATIONS = [
    {
        id: "CONTRACTOR_SETTING",
        name: "SETTINGS",
        icon: ic_settings,
        hide: isMobileWebView(),
        accessTo: "C",
        country: ["-1"],
        onClick: () => {
            RouteManager.navigateToPage(PAGE_ROUTES.CONTRACTOR_SETTING)
            if(!isViewportLarge()) {
                SideBarService.toggleSideBar()
            }
        }
    },
    {
        id: "DASHBOARD",
        name: "DASHBOARD",
        icon: ic_dashboard,
        hide: isMobileWebView(),
        accessTo: "OAEHR",
        country: ["-1"],
        isDefaultViewForPWUsers: true,
        onClick: () => {
            RouteManager.navigateToPage("/")
            if(!isViewportLarge()) {
                SideBarService.toggleSideBar()
            }
        }
    },
    {
        id: "PAYSTUB",
        name: "Paystub",
        hide: isMobileWebView(),
        icon: paystub_icon,
        accessTo: "EHR",
        // accessToModule: MODULE.PAYSTUB,
        country: ["-1"],
        onClick: () => {
            RouteManager.navigateToPage(PAGE_ROUTES.PAYSTUB_LIST)
            if(!isViewportLarge()) {
                SideBarService.toggleSideBar()
            }
        }
    },
    {
        id: "SELF_ASSESSMENT",
        name: "Performance",
        icon: ic_performance,
        accessTo: "EHR",
        country: ["-1"],
        hide: isMobileWebView(),
        subItems: [
          {
            id: "APPRAISAL_CYCLE_LIST",
            name: "Appraisal Cycles",
            accessTo: "-1",
            country: ["-1"],
            hide: isMobileWebView(),
            accessToModule: MODULE.PERFORMANCE_APPRAISAL_CYCLE,
            onClick: () => {
                RouteManager.navigateToPage(PAGE_ROUTES.APPRAISAL_CYCLE_LIST)
                if(!isViewportLarge()) {
                    SideBarService.toggleSideBar();
                }
            }
          },
          {
            id: "Performance",
            name: "Performance",
            accessTo: "EHR",
            country: ["-1"],
            hide: isMobileWebView(),
            onClick: () => {
              RouteManager.navigateToPage(PAGE_ROUTES.SELF_ASSESSMENT)
              if (!isViewportLarge()) {
                SideBarService.toggleSideBar();
              }
            }
          },
          {
            id: "ASSESSMENT_REVIEW",
            name: "Review",
            accessTo: "EHR",
            country: ["-1"],
            hide: isMobileWebView(),
            accessToModule: MODULE.PERFORMANCE_REVIEW,
            onClick: () => {
                RouteManager.navigateToPage(PAGE_ROUTES.ASSESSMENT_REVIEW)
                if(!isViewportLarge()) {
                    SideBarService.toggleSideBar();
                }
            }
        },
          {
            id: "GOAL",
            name: "Goal",
            accessTo: OWNER_ADMIN_EMPLOYEE_HIRING_ADMIN,
            country: ["-1"],
            hide: isMobileWebView(),
            onClick: () => {
                RouteManager.navigateToPage(PAGE_ROUTES.PERFORMANCE.GOAL)
                if(!isViewportLarge()) {
                    SideBarService.toggleSideBar();
                }
            }
        }
      ]
    },
    {
        id: "HIRING",
        name: "Hiring",
        icon: ic_hiring,
        accessTo: "OAHR",
        accessToModule: [MODULE.CANDIDATE, MODULE.JOB_OPENING, MODULE.JOB_PIPELINE, MODULE.JOB_FORM, MODULE.EMAIL_TEMPLATE],
        country: ["-1"],
        subItems: [
            {
                id: "CANDIDATE",
                name: "Candidates",
                // icon: ic_contacts,
                accessTo: "OAHR",
                accessToModule: MODULE.CANDIDATE,
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage("/candidate")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "JOB_OPENING",
                name: "Job Openings",
                // icon: ic_list,
                accessTo: "OAHR",
                accessToModule: MODULE.JOB_OPENING,
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage("/Job-opening")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "JOB_PIPELINE",
                name: "Job Pipelines",
                // icon: ic_deals,
                accessTo: "OAHR",
                accessToModule: MODULE.JOB_PIPELINE,
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage("/job-pipeline")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "JOB_FORMS",
                name: "Job Forms",
                // icon: ic_forms,
                accessTo: "OAHR",
                accessToModule: MODULE.JOB_FORM,
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage("/job-forms")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
              id: "EMAIL_TEMPLATE_LIST",
              name: "Email Template",
              // icon: ic_forms,
              accessTo: "OAHR",
              accessToModule: MODULE.EMAIL_TEMPLATE,
              country: ["-1"],
              onClick: () => {
                  RouteManager.navigateToPage(PAGE_ROUTES.EMAIL_TEMPLATE.LIST)
                  if(!isViewportLarge()) {
                      SideBarService.toggleSideBar()
                  }
              }
          }
        ]
    },
    {
        id: "PAYROLL",
        name: "Payroll",
        icon: ic_payroll,
        accessTo: "OA",
        country: ["-1"],
        accessToModule: [MODULE.PAY_SCHEDULE,  MODULE.PAYRUN,  MODULE.EMPLOYEE,  MODULE.CONTRACTOR, MODULE.CONTRACTOR_PAYRUN, MODULE.EARNINGS_AND_DEDUCTIONS, MODULE.EARNING_DEDUCTION_TEMPLETE, MODULE.BENEFITS],
        subItems: [
            {
                id: "PAY_SCHEDULE_LIST",
                name: "Pay Schedules",
                // icon: pay_schedule,
                accessTo: "OA",
                accessToModule: MODULE.PAY_SCHEDULE,
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage("/pay-schedule");
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar();
                    }
                }
            },
            {
                id: "PAYRUNS",
                name: "Payruns",
                accessToModule: [MODULE.PAYRUN, MODULE.SALARY],
                hasEachAccess: true,
                // icon: ic_cards,
                accessTo: "OA",
                country: ["-1"],
                onClick: () => {
                  if (PermissionUtils.hasMultiModuleAccess( [MODULE.PAYRUN, MODULE.SALARY], [ACTION.VIEW,ACTION.CREATE, ACTION.DELETE, ACTION.EDIT, ACTION.IMPORT,ACTION.SUBMIT, ACTION.EXPORT ]), true ) {
                        RouteManager.navigateToPage("/payrolls");
                        if(!isViewportLarge()) {
                            SideBarService.toggleSideBar()
                        }
                    } else {
                        showAccessDeniedAlert();
                    }
                }
            },
            {
                id: "EMPLOYEE_LIST",
                name: "Employee List",
                // icon: ic_emp_list,
                accessTo: "OA",
                accessToModule: MODULE.EMPLOYEE,
                country: ["-1"],
                onClick: () => {
                  if(TenantService.get(TENANT.IS_ADMIN) || 
                  PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.VIEW,ACTION.CREATE, ACTION.DELETE, ACTION.EDIT, ACTION.IMPORT])) {
                    RouteManager.navigateToPage("/employee")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                  } else {
                    RouteManager.navigateToPage(
                      PAGE_ROUTES.EMPLOYEE_DETAILS,
                      `&id=${TenantService.get(TENANT.USER_ID)}&isEdit=true&step=0`
                  );
                  }
                  
                    
                }
            },
            {
                id: "CONTRACTOR_LIST",
                name: "Contractor List",
                // icon: ic_cards,
                accessTo: "OA",
                accessToModule: MODULE.CONTRACTOR, 
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.CONTRACTOR_LIST)
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "CONTRACTOR_PAYRUN",
                name: "Contractor Payrun",
                // icon: ic_cards,
                accessTo: "OA",
                accessToModule: [MODULE.CONTRACTOR_PAYRUN, MODULE.SALARY],
                hasEachAccess: true,
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.CONTRACTOR_PAYRUN_LIST)
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
              id: "GIRO",
              name: "Giro",
              // icon: ic_cards,
              accessTo: "OA",
              accessToModule: [MODULE.GIRO, MODULE.SALARY],
              hasEachAccess: true,
              country: ["SG", "MY"],
              onClick: () => {
                  RouteManager.navigateToPage(PAGE_ROUTES.GIRO)
                  if(!isViewportLarge()) {
                      SideBarService.toggleSideBar()
                  }
              }
          },
            {
                id: "COMPONENT",
                name: "COMPONENTS",
                // icon: ic_component,
                accessTo: "OA",
                accessToModule: MODULE.EARNINGS_AND_DEDUCTIONS,
                country: ["-1"],
                hide: isMobileWebView(),
                onClick: () => {
                    if (PermissionUtils.hasMultiModuleAccess([MODULE.SALARY, MODULE.EARNINGS_AND_DEDUCTIONS], [ACTION.VIEW, ACTION.EDIT])) {
                        RouteManager.navigateToPage("/component")
                        if(!isViewportLarge()) {
                            SideBarService.toggleSideBar()
                        }
                    } else {
                        showAccessDeniedAlert();
                    }
                }
            },
            {
                id: "COMPONENT_GROUPS",
                name: "COMPONENT_TEMPLATE",
                // icon: custom_field,
                accessTo: "OA",
                accessToModule: MODULE.EARNING_DEDUCTION_TEMPLETE,
                hide: isMobileWebView(),
                country: ["-1"],
                onClick: () => {
                    if (PermissionUtils.hasMultiModuleAccess([MODULE.SALARY, MODULE.EARNING_DEDUCTION_TEMPLETE], [ACTION.VIEW, ACTION.EDIT])) {
                        RouteManager.navigateToPage("/component-groups");
                    } else {
                        showAccessDeniedAlert();
                    }
                }
            },
            {
                id: "BENEFITS",
                name: "Benefits",
                // icon: ic_component,
                accessTo: "OA",
                country: ["US"],
                hide: isMobileWebView(),
                accessToModule: MODULE.BENEFITS,
                onClick: () => {
                    if (PermissionUtils.hasAccess(MODULE.SALARY, [ACTION.VIEW, ACTION.EDIT])) {
                        RouteManager.navigateToPage(PAGE_ROUTES.BENEFITS)
                        if(!isViewportLarge()) {
                            SideBarService.toggleSideBar()
                        }
                    } else {
                        showAccessDeniedAlert();
                    }
                }
            }
        ]
    },
    {
        id: "COMPOFF",
        name: "Compensatory Off",
        icon: ic_timeoff,
        hide: isMobileWebView(),
        accessTo: "OAEHR",
        accessToModule: [MODULE.COMP_OFF_CONFIGURATION, MODULE.MANAGE_COMP_OFF, MODULE.MANAGE_COMP_OFF_REQUEST, MODULE.MY_COMP_OFF],
        country: ["-1"],
        subItems:[
            {
            id: "COMP_OFF_CONFIGURATION",
            name: "Configuration",
            accessTo: "OA",
            accessToModule: MODULE.COMP_OFF_CONFIGURATION,
            country: ["-1"],
            onClick: () => {
              if (!isProfessionalPlan()) {
                showUpgradePlanAlert('Compensatory Off');
                return;
              }
              RouteManager.navigateToPage("/compoff/configure-comp-off")
              if (!isViewportLarge()) {
                SideBarService.toggleSideBar()
              }
            }
        },{
            id: "MANAGE_COMP_OFF",
            name: "Manage Comp Offs",
            accessTo: "OA",
            accessToModule: MODULE.MANAGE_COMP_OFF,
            country: ["-1"],
            onClick: () => {
              if (!isProfessionalPlan()) {
                showUpgradePlanAlert('Compensatory Off');
                return;
              }

              RouteManager.navigateToPage("/compoff/manage-comp-off")
              if (!isViewportLarge()) {
                SideBarService.toggleSideBar()
              }
            }
        },{
            id: "MANAGE_COMP_OFF_REQUEST",
            name: "Manage Comp Off Requests",
            accessTo: "OA",
            accessToModule: MODULE.MANAGE_COMP_OFF_REQUEST,
            country: ["-1"],
            onClick: () => {
              if (!isProfessionalPlan()) {
                showUpgradePlanAlert('Compensatory Off');
                return;
              }

              RouteManager.navigateToPage("/compoff/manage-comp-off-request")
              if (!isViewportLarge()) {
                SideBarService.toggleSideBar()
              }
            }
        },{
            id: "MY_COMP_OFF",
            name: "My Comp Offs",
            accessTo: "OAEHR",
            accessToModule: MODULE.MY_COMP_OFF,
            country: ["-1"],
            onClick: () => {
                if (!isProfessionalPlan()) {
                  showUpgradePlanAlert('Compensatory Off');
                  return;
                }
                RouteManager.navigateToPage(PAGE_ROUTES.COMP_OFF.MY_COMP_OFF)
                if(!isViewportLarge()) {
                    SideBarService.toggleSideBar()
                }
            }
        }
    ]
    },
    {
        id: "ELEAVE",
        name: "ELEAVE",
        icon: ic_timeoff,
        hide: isMobileWebView(),
        accessTo: "OAEHR",
        accessToModule: [MODULE.TEAM_REPORT, MODULE.MANAGE_REQUESTS,MODULE.COMPANY_HOLIDAYS,MODULE.TIME_OFF_REPORT,MODULE.TIME_OFF_POLICY,MODULE.TIME_OFF_COMPANY_SETTINGS],
        country: ["-1"],
        subItems: [
            {
                id: "MY_ATTENDANCE",
                name: "MY_ATTENDANCE",
                // icon: ic_my_attendance,
                accessTo: "OAEHR",
                // accessToModule: MODULE.MY_ATTENDANCE,
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage("/my-attendance")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "TEAM_ATTENDANCE",
                name: "Team Report",
                // icon: ic_attendance_team,
                accessTo: "OAM",
                accessToModule: MODULE.TEAM_REPORT,
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage("/team-attendance")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "REQUEST",
                name: "REQUEST",
                // icon: ic_attendance_team,
                accessTo: "OAEHR",
                country: ["-1"],
                onClick: () => {
                    window.open(ApiConstants.PRODUCT_URL_ELEAVE+"requests/leave", "_blank")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "APPLICATION",
                name: "APPLICATION",
                // icon: ic_attendance_team,
                accessTo: "OAEHR",
                country: ["-1"],
                onClick: () => {
                    window.open(ApiConstants.PRODUCT_URL_ELEAVE+"applications/leave", "_blank")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "CALENDAR",
                name: "Calendar",
                // icon: ic_attendance_team,
                accessTo: "EHR",
                accessToModule: MODULE.COMPANY_HOLIDAYS,
                country: ["-1"],
                onClick: () => {
                    window.open(ApiConstants.PRODUCT_URL_ELEAVE+"calendar/companysettings", "_blank")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "LEAVE_ENTITLEMENT",
                name: "LEAVE_ENTITLEMENT",
                // icon: ic_attendance_team,
                accessToModule: MODULE.TIME_OFF_REPORT,
                accessTo: "OAEHR",
                country: ["-1"],
                onClick: () => {
                    window.open(ApiConstants.PRODUCT_URL_ELEAVE+"leaveentitlement/leaves", "_blank")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "LEAVE_MANAGEMENT",
                name: "LEAVE_MANAGEMENT",
                // icon: ic_attendance_team,
                accessToModule: MODULE.TIME_OFF_POLICY,
                accessTo: "OA",
                country: ["-1"],
                onClick: () => {
                    window.open(ApiConstants.PRODUCT_URL_ELEAVE+"settings/leavemanagement/leaves", "_blank")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "ELEAVE_SETTINGS",
                name: "ELEAVE_SETTINGS",
                // icon: ic_attendance_team,
                accessToModule: MODULE.TIME_OFF_COMPANY_SETTINGS,
                accessTo: "OA",
                country: ["-1"],
                onClick: () => {
                    window.open(ApiConstants.PRODUCT_URL_ELEAVE+"settings/companysetting", "_blank")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            }
        ]
    },


    {
        id: "EXPENSE",
        name: "Expense",
        icon: ic_expense,
        accessTo: "OAEHR",
        country: ["-1"],
        hide: isMobileWebView(),
        accessToModule: [MODULE.EXPENSE_CLAIM, MODULE.EXPENSE_ADMIN_SETTING, MODULE.EXPENSE_INTEGRATION_SETTING],
        subItems: [
            {
                id: "EXPENSE_CLAIMS",
                name: "Expense Claims",
                accessTo: "OAEHR",
                accessToModule: MODULE.EXPENSE_CLAIM,
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage("/expense-claims")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "EXPENSE_ADMIN_SETTING",
                name: "Admin Settings",
                accessTo: "OA",
                accessToModule: MODULE.EXPENSE_ADMIN_SETTING,
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.EXPENSE.EXPENSE_ADMIN_SETTING)
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            }
        ]
    },
    {
        id: "SHIFT_MANAGEMENT",
        name: "Shift Management",
        icon: shift_management,
        accessTo: "OA",
        country: ["-1"],
        accessToModule: [MODULE.SHIFT, MODULE.SHIFT_ASSIGNMENT, MODULE.OVERTIME_POLICY, MODULE.OT_MULTIPLIER],
        subItems: [
            {
                id: "SHIFTS",
                name: "Shifts",
                accessTo: "OA",
                accessToModule: MODULE.SHIFT,
                country: ["-1"],
                onClick: () => {
                    if (!isProfessionalPlan()) {
                      showUpgradePlanAlert('Shifts');
                      return;
                    }

                    RouteManager.navigateToPage(PAGE_ROUTES.SHIFTS)
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar();
                    }
                }
            },
            {
                id: "SHIFT_MEMBERS",
                name: "Shift Assignment",
                accessTo: "OA",
                accessToModule: MODULE.SHIFT_ASSIGNMENT,
                country: ["-1"],
                onClick: () => {
                    if (!isProfessionalPlan()) {
                      showUpgradePlanAlert('Shifts');
                      return;
                    }

                    RouteManager.navigateToPage(PAGE_ROUTES.SHIFT_MEMBERS)
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar();
                    }
                }
            },
            {
                id: "OVERTIME_LIST",
                name: "Overtime Policy",
                accessTo: "OA",
                accessToModule: MODULE.OVERTIME_POLICY,
                country: ["-1"],
                onClick: () => {
                  if (!isProfessionalPlan()) {
                    showUpgradePlanAlert('Overtime');
                    return;
                  }

                  RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_LIST)
                  if (!isViewportLarge()) {
                    SideBarService.toggleSideBar();
                  }
                }
            },
            {
              id: "OVERTIME_RATE_CONFIG",
              name: "Overtime Payroll Multiplier",
              accessTo: "OA",
              country: ["-1"],
              accessToModule: MODULE.OT_MULTIPLIER,
              onClick: () => {
                  if (!isProfessionalPlan()) {
                    showUpgradePlanAlert('Overtime');
                    return;
                  }

                  RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_RATE_CONFIG)
                  if(!isViewportLarge()) {
                      SideBarService.toggleSideBar();
                  }
              }
          }
        ]
    },
    {
        id: "TIMESHEET",
        name: "Timesheet",
        icon: shift_management,
        hide: isMobileWebView(),
        accessTo: "OAEHR",
        accessToModule: [MODULE.TIMESHEET],
        country: ["-1"],
        subItems: [
            {
                id: "PROJECTS",
                name: "Projects",
                accessTo: "OA",
                country: ["-1"],
                accessToModule: MODULE.TIMESHEET,
                onClick: () => {
                  //Note:will use leter if(!UserManager.hasBooksAccess()) {
                  //   showBooksAccessAlert('Books')
                  //   return
                  // }
                    RouteManager.navigateToPage(PAGE_ROUTES.PROJECTS);
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar();
                    }
                }
            },
            {
                id: "TASKS",
                name: "Tasks",
                accessTo: "OA",
                country: ["-1"],
                accessToModule: MODULE.TIMESHEET,
                onClick: () => {
                  //Note:will use leter if(!UserManager.hasBooksAccess()) {
                  //   showBooksAccessAlert('Books')
                  //   return
                  // }
                    RouteManager.navigateToPage(PAGE_ROUTES.TASKS);
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar();
                    }
                }
            },
            {
                id: "EMPLOYEE_MAPPING",
                name: "Employee Mapping",
                accessTo: "OA",
                hide:true,
                country: ["-1"],
                accessToModule: MODULE.TIMESHEET,
                onClick: () => {
                  // if(!UserManager.hasBooksAccess()) {
                  //   showBooksAccessAlert('Books')
                  //   return
                  // }
                    RouteManager.navigateToPage(PAGE_ROUTES.EMPLOYEE_MAPPING);
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar();
                    }
                }
            },
            {
                id: "TIMESHEET_ENTRY",
                name: "Timesheet Entry",
                accessTo: "OAEHR",
                country: ["-1"],
                accessToModule: MODULE.TIMESHEET,
                onClick: () => {
                  //Note:will use leter if(!UserManager.hasBooksAccess()) {
                  //   showBooksAccessAlert('Books')
                  //   return
                  // }
                    RouteManager.navigateToPage(PAGE_ROUTES.TIMESHEET_ENTRY);
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar();
                    }
                }
            },
            {
                id: "TIMESHEET_REPORTS",
                name: "Reports",
                accessTo: "OA",
                country: ["-1"],
                accessToModule: MODULE.TIMESHEET,
                route: PAGE_ROUTES.TIMESHEET_REPORT_LIST,
                onClick: () => {
                  //Note:will use leter if(!UserManager.hasBooksAccess()) {
                  //   showBooksAccessAlert('Books');
                  //   return
                  // }
                    RouteManager.navigateToPage(PAGE_ROUTES.TIMESHEET_REPORT_LIST);
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar();
                    }
                }
            },
            {
                id: "ADMIN_TIMESHEET_REPORT_CALENDAR",
                name: "Clocked In employees",
                accessTo: "OA",
                country: ["-1"],
                accessToModule: MODULE.TIMESHEET,
                route: PAGE_ROUTES.TIMESHEET_REPORT_CALENDAR,
                onClick: () => {
                  //Note:will use leter if(!UserManager.hasBooksAccess()) {
                  //   showBooksAccessAlert('Books');
                  //   return
                  // }
                    RouteManager.navigateToPage(PAGE_ROUTES.TIMESHEET_REPORT_CALENDAR);
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar();
                    }
                }
              
            }
        ]
    },
    {
        id: "INVESTMENTS",
        name: "Investments",
        icon: ic_summarize,
        hide: isMobileWebView(),
        accessTo: "OAEHR",
        country: ["IN"],
        accessToModule: [MODULE.IT_DECLARATION, MODULE.EMPLOYEE_DECLARATION, MODULE.POI, MODULE.EMPLOYEE_POI, MODULE.EMPLOYEE_APPROVAL],
        subItems: [
            {
                id: "IT_DECLARATION",
                name: "IT Declaration",
                accessTo: "OA",
                country: ["IN"],
                accessToModule: MODULE.IT_DECLARATION,
                onClick: () => {
                    RouteManager.navigateToPage("/investments/it-declaration")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "EMPLOYEES_DECLARATION",
                name: "Employees Declaration",
                accessTo: "OA",
                country: ["IN"],
                accessToModule: MODULE.EMPLOYEE_DECLARATION,
                onClick: () => {
                    RouteManager.navigateToPage("/investments/employees-declaration")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "MY_IT_DECLARATION",
                name: "My IT Declaration",
                accessTo: "OAEHR",
                country: ["IN"],
                onClick: () => {
                    RouteManager.navigateToPage("/investments/my-it-declaration")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "POI",
                name: "POI",
                accessTo: "OA",
                country: ["IN"],
                accessToModule: MODULE.POI,
                onClick: () => {
                    RouteManager.navigateToPage("/investments/poi")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "EMPLOYEES_POI",
                name: "Employees POI",
                accessTo: "OA",
                country: ["IN"],
                accessToModule: MODULE.EMPLOYEE_POI,
                onClick: () => {
                    RouteManager.navigateToPage("/investments/employees-poi")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "MY_POI",
                name: "My POI",
                accessTo: "OAEHR",
                country: ["IN"],
                onClick: () => {
                    RouteManager.navigateToPage("/investments/my-poi")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "EMPLOYEES_APPROVAL",
                name: "Employees Approval",
                accessTo: "OA",
                country: ["IN"],
                accessToModule: MODULE.EMPLOYEE_APPROVAL,
                onClick: () => {
                    RouteManager.navigateToPage("/investments/employees-approval")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "MY_APPROVAL",
                name: "My Approval",
                accessTo: "OA",
                country: ["IN"],
                onClick: () => {
                    RouteManager.navigateToPage("/investments/my-approval")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            }
        ]
    },
    {
        id: "PERFORMANCE",
        name: "Performance",
        icon: ic_performance,
        accessTo: "OA",
        country: ["-1"],
        hide: isMobileWebView(),
        accessToModule: [MODULE.PERFORMANCE_APPRAISAL_CYCLE, MODULE.PERFORMANCE_REVIEW, MODULE.PERFORMANCE_GOAL],
        subItems: [
          {
            id: "APPRAISAL_CYCLE_LIST",
            name: "Appraisal Cycles",
            accessTo: "OA",
            country: ["-1"],
            hide: isMobileWebView(),
            accessToModule: MODULE.PERFORMANCE_APPRAISAL_CYCLE,
            onClick: () => {
                RouteManager.navigateToPage(PAGE_ROUTES.APPRAISAL_CYCLE_LIST)
                if(!isViewportLarge()) {
                    SideBarService.toggleSideBar();
                }
            }
          },
          {
                id: "APPRAISAL_CYCLE",
                name: "Appraisal Cycle",
                accessTo: "OA",
                country: ["-1"],
                hide: true,
                accessToModule: MODULE.PERFORMANCE_APPRAISAL_CYCLE,
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.APPRAISAL_CYCLE)
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar();
                    }
                }
            },
            {
                id: "ASSESSMENT_REVIEW",
                name: "Review",
                accessTo: "OA",
                country: ["-1"],
                hide: isMobileWebView(),
                accessToModule: MODULE.PERFORMANCE_REVIEW,
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.ASSESSMENT_REVIEW)
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar();
                    }
                }
            },
            {
              id: "GOAL",
              name: "Goal",
              accessTo: "OA",
              country: ["-1"],
              hide: isMobileWebView(),
              accessToModule: MODULE.PERFORMANCE_GOAL,
              onClick: () => {
                  RouteManager.navigateToPage(PAGE_ROUTES.PERFORMANCE.GOAL)
                  if(!isViewportLarge()) {
                      SideBarService.toggleSideBar();
                  }
              }
          }
          
        ]
    },
    {
        id: "REPORT_LIST",
        name: "Reports",
        icon: ic_reports,
        hide: isMobileWebView(),
        accessTo: "OA",
        country: ["-1"],
        accessToModule: MODULE.REPORTS,
        onClick: () => {
            if (PermissionUtils.hasAccess(MODULE.SALARY, [ACTION.VIEW, ACTION.EDIT]) || PermissionUtils.hasAccess(MODULE.REPORTS, [ACTION.VIEW, ACTION.EDIT])) {
                RouteManager.navigateToPage(PAGE_ROUTES.REPORTS_LIST);
                if(!isViewportLarge()) {
                    SideBarService.toggleSideBar();
                }
            } else {
                showAccessDeniedAlert();
            }
        }
    },
    {
        id: "REPORT_LIST",
        name: "Report",
        icon: ic_reports,
        accessTo: "EHR",
        country: ["US"],
        accessToModule: MODULE.REPORTS,
        hide: isMobileWebView(),
        onClick: () => {
            RouteManager.navigateToPage(PAGE_ROUTES.REPORTS_LIST);
        }
    },
    {
        id: "AUTOMATION",
        name: "Automations",
        icon: ic_automation,
        accessTo: "OA",
        country:["-1"],
        accessToModule: MODULE.AUTOMATION,
        hide: isMobileWebView(),
        onClick: () => {
            RouteManager.navigateToPage(PAGE_ROUTES.AUTOMATION)
            if (!isViewportLarge()) {
                SideBarService.toggleSideBar()
            }
        }
    },
    {
        id: "BIOMETRIC_ATTENDANCE_SETUP",
        name: "Biometric Attendance Settings",
        icon: ic_timeoff,
        hide: isMobileWebView(),
        accessTo: "OA",
        country: ["-1"],
        accessToModule: MODULE.BIO_ATTENDANCE_SETTING,
        subItems:[],
        onClick: () => {
            if (!isProfessionalPlan()) {
                showUpgradePlanAlert('Biometric Attendance');
            } else {
                RouteManager.navigateToPage(PAGE_ROUTES.BIOMETRIC_ATTENDANCE_SETUP)
                if(!isViewportLarge()) {
                    SideBarService.toggleSideBar()
                }
            }
        }
    },
    {
      id: "POLICY_AND_RESOURCES",
      name: "Policy & Resources",
      icon: policy_n_resources,
      hide: isMobileWebView(),
      accessTo: "OAEHR",
      country: ["-1"],
      accessToModule: MODULE.POLICY_AND_RESOURCES,
      subItems:[],
      onClick: () => {
          RouteManager.navigateToPage(PAGE_ROUTES.POLICY_AND_RESOURCES.LIST)
          if(!isViewportLarge()) {
              SideBarService.toggleSideBar()
          }
      }
    },
    {
        id: "COMPANY_SETTINGS",
        name: "Company Settings",
        icon: ic_companysetting,
        accessTo: "OA",
        accessToModule: [MODULE.COMPANY_SETTINGS, MODULE.IMPORT_LOG],
        country: ["-1"],
        hide: isMobileWebView(),
        subItems: [
            {
                id: 'COMPANY_DETAILS',
                name: "Company Details",
                // icon: ic_payroll_setup,
                accessTo: "OA",
                accessToModule: MODULE.COMPANY_SETTINGS,
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.COMPANY_DETAILS)
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "IN_TAX_DETAILS",
                name: "Tax Details",
                // icon: tax_details,
                accessTo: "OA",
                accessToModule: MODULE.COMPANY_SETTINGS,
                country: ["IN"],
                onClick: () => {
                    RouteManager.navigateToPage("/in/tax-details")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "US_TAX_DETAILS",
                name: "Tax Details",
                // icon: tax_details,
                accessTo: "OA",
                country: ["US"],
                accessToModule: MODULE.COMPANY_SETTINGS,
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.US_TAX)
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
              id: "MY_TAX_DETAILS",
              name: "Tax Details",
              // icon: tax_details,
              accessTo: "OA",
              accessToModule: MODULE.COMPANY_SETTINGS,
              country: ["MY"],
              onClick: () => {
                  RouteManager.navigateToPage(PAGE_ROUTES.MY_TAX_DETAILS)
                  if(!isViewportLarge()) {
                      SideBarService.toggleSideBar()
                  }
              }
            },
            {
              id: "MY_USER_TAX_DETAILS",
              name: "User Tax Details",
              accessTo: "OA",
              accessToModule: MODULE.COMPANY_SETTINGS,
              country: ["MY"],
              onClick: () => {
                  RouteManager.navigateToPage(PAGE_ROUTES.MY_USER_TAX_DETAILS)
                  if(!isViewportLarge()) {
                      SideBarService.toggleSideBar()
                  }
              }
            },
            {
                id: "FILLING_AUTHORIZATION",
                name: "Filing Authorization",
                accessTo: "OA",
                country: ["US"],
                hide: true,
                accessToModule: MODULE.COMPANY_SETTINGS,
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.FILLING_AUTHORIZATION)
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "CUSTOM_FIELDS",
                name: "Custom Fields",
                // icon: custom_field,
                accessTo: "OA",
                country: ["-1"],
                accessToModule: MODULE.COMPANY_SETTINGS,
                onClick: () => {
                    RouteManager.navigateToPage("/custom-fields")
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "BANK_ACCOUNTS",
                name: "Bank Accounts",
                // icon: custom_field,
                accessTo: "OA",
                country: ["SG", "MY", "US"],
                accessToModule: MODULE.COMPANY_SETTINGS,
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.BANK_ACCOUNTS);
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {

                id: "IMPORT_LOG",
                name: "Import Log",
                // icon: custom_field,
                accessTo: "OA",
                accessToModule: MODULE.IMPORT_LOG,
                country: ["-1"],
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.IMPORT_LOG)
                    if (!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }

            },
            {
                id: "PAYSLIP_DESIGN",
                name: "Payslip Design",
                // icon: ic_cards,
                accessTo: "OA",
                country: ["-1"],
                accessToModule: MODULE.COMPANY_SETTINGS,
                hide: isMobileWebView(),
                onClick: () => {
                  if(Utility.isEmpty(TenantService.get(TENANT.DEFAULT_PAYSLIP))) {
                    showLoader()
                    Tenant.getDefaultPayslipUUID().then(res=>{
                      if(res && res['templates']) {
                        TenantService.set(TENANT.DEFAULT_PAYSLIP,res['templates']);
                        window.open(`${ApiConstants.PRODUCT_URL_DOCUMENT_BUILDER}${getDefaultPayslipUUID()}`, "_blank");
                      }
                      removeLoader()
                    },error=>{
                      removeLoader()
                    })
                  } else {
                    window.open(`${ApiConstants.PRODUCT_URL_DOCUMENT_BUILDER}${getDefaultPayslipUUID()}`, "_blank");
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                  }
                }
            },
            {
                id: "MANAGE_LOCATION",
                name: "Manage Location",
                accessTo: "OA",
                country:["-1"],
                accessToModule: MODULE.COMPANY_SETTINGS,
                hide: isMobileWebView(),
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.MANAGE_LOCATION)
                    if (!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "NOTIFICATION_SETTING",
                name: "Notification Settings",
                accessTo: "OA",
                country:["-1"],
                accessToModule: MODULE.COMPANY_SETTINGS,
                // hide: isMobileWebView(),
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.NOTIFICATION_SETTING)
                    if (!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "ATTENDANCE_SETTING",
                name: i18next.t("GEO_FENCING_SETTING"),
                accessTo: "OA",
                country:["-1"],
                accessToModule: MODULE.COMPANY_SETTINGS,
                // hide: isMobileWebView(),
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.ATTENDANCE_SETTING)
                    if (!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "PAYMENT_LOGS",
                name: "Payment Logs",
                // icon: custom_field,
                accessTo: "OA",
                country: ["SG", "MY"],
                accessToModule: MODULE.COMPANY_SETTINGS,
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.PAYMENT_LOGS);
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            },
            {
                id: "IRAS_SETTINGS",
                name: "IRAS Settings",
                // icon: custom_field,
                accessTo: "OA",
                accessToModule: MODULE.COMPANY_SETTINGS,
                country: ["SG"],
                onClick: () => {
                    RouteManager.navigateToPage(PAGE_ROUTES.REPORT.SG.IRAS_SETTINGS);
                    if(!isViewportLarge()) {
                        SideBarService.toggleSideBar()
                    }
                }
            }
        ]
    },
    {
        id: "SETTINGS",
        name: "Settings",
        icon: ic_settings,
        accessTo: "OA",
        country: ["-1"],
        hide: isMobileWebView(),
        onClick: () => {
            RouteManager.navigateToPage("/settings")
            if(!isViewportLarge()) {
                SideBarService.toggleSideBar()
            }
        },
        className: "mt-auto"
    },
];

export const INTEGRATION_SETTING = {
    id: "INTEGRATION_SETTINGS",
    name: "Integration Settings",
    accessToModule: MODULE.COMPANY_SETTINGS,
    // icon: custom_field,
    hide: true,
    accessTo: "OA",
    country: ["-1"],
    onClick: () => RouteManager.navigateToPage("/integration-settings")
}

export const EXPENSE_INTEGRATION_SETTING = {
    id: "EXPENSE_INTEGRATION_SETTINGS",
    name: "Integration Settings",
    // icon: custom_field,
    accessToModule: MODULE.EXPENSE_INTEGRATION_SETTING,
    hide: true,
    accessTo: "OA",
    country: ["-1"],
    onClick: () => RouteManager.navigateToPage(PAGE_ROUTES.EXPENSE.EXPENSE_INTEGARTION_SETTINGS)
}

export const CHECK_DESIGN = {
    id: "CHECK_DESIGN",
    name: "Check Design",
    hide: true,
    accessTo: "OA",
    country: ["US"],
    onClick: () => {
        window.open(`${ApiConstants.PRODUCT_URL_DOCUMENT_BUILDER}?type=PAYROLL_CHECK`, "_blank")
        if(!isViewportLarge()) {
            SideBarService.toggleSideBar()
        }
    }
}

export const ASSESSMENT_REVIEW = {
  id: "ASSESSMENT_REVIEW",
  name: "Review",
  accessTo: "OAEHR",
  country: ["-1"],
  hide: true,
  onClick: () => {
      RouteManager.navigateToPage(PAGE_ROUTES.ASSESSMENT_REVIEW)
      if(!isViewportLarge()) {
          SideBarService.toggleSideBar();
      }
  }
}

export const EXPENSES = {
  id: "EXPENSE",
  name: "Expense",
  icon: ic_expense,
  accessTo: "OAEHR",
  country: ["-1"],
  hide: isMobileWebView(),
  onClick: () => {
    window.open(ApiConstants.PRODUCT_URL_EXPENSES, "_blank");
    if (!isViewportLarge()) {
      SideBarService.toggleSideBar();
    }
  },
};
